import { ChartData, ChartOptions } from "chart.js";
import React from "react";
import { Pie } from "react-chartjs-2";

interface Props {
  options?: ChartOptions<"pie">;
  data: ChartData<"pie">;
}

const PieChart = ({ options, data }: Props) => {
  return <Pie options={options} data={data} />;
};

PieChart.defaultProps = {
  options: undefined,
};

export default PieChart;
